import type { StoredUser } from './reconstruct-user.utils';
import type { AuthenticatedUser } from '@/features/auth/types/authenticated-user.type';

export function partializeUser(user: AuthenticatedUser | null): StoredUser | null {
  console.log('💾 [PARTIALIZE] Saving user to localStorage:', {
    hasUser: !!user,
    userId: user?.userId,
    email: user?.email,
    allKeys: user ? Object.keys(user) : [],
    rawUser: user,
  });

  if (!user) return null;

  const storedUser = {
    userId: user.userId,
    displayName: user.displayName,
    email: user.email,
    accessToken: user.accessToken,
    refreshToken: user.refreshToken,
    emailVerified: user.emailVerified,
    avatarUrl: user.avatarUrl ?? null,
    permissions: user.permissions ?? [],
    role: user.role ?? null,
  };

  console.log('💾 [PARTIALIZE] Stored user object:', storedUser);

  return storedUser;
}
